import Graph from './component'

export default Graph
